import api from './api';

const inventoryReportsService = {
  // Get inventory reports data
  getInventoryReports: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.category) queryParams.append('category', params.category);
      if (params.productId) queryParams.append('productId', params.productId);
      if (params.warehouse) queryParams.append('warehouse', params.warehouse);
      if (params.lowStockThreshold) queryParams.append('lowStockThreshold', params.lowStockThreshold);

      const queryString = queryParams.toString();
      const url = `/inventory-reports/reports${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching inventory reports:', error);
      throw error;
    }
  },

  // Get filter options
  getInventoryFilterOptions: async () => {
    try {
      const response = await api.get('/inventory-reports/filters');
      return response.data;
    } catch (error) {
      console.error('Error fetching filter options:', error);
      throw error;
    }
  }
};

export default inventoryReportsService;

